import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import { ReactSvg } from '../../../../shared/vector-images';
import Text from '../../../../shared/_deprecated/elements/Text/Text';
import styles from './Heading.scss';

const cx = classNames.bind(styles);

// TODO: Redo the headings using proper semantic heading type tags ie. '<h1>'

export const SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
};

const Heading = (props) => {
  const { className, text, size, type, align, wrapLongText, icon, iconColour } =
    props;

  // Set element sizes
  let iconSize;
  let textSize;
  switch (size) {
    case SIZES.SMALL:
      iconSize = 24;
      textSize = '0';
      break;

    case SIZES.MEDIUM:
      iconSize = 30;
      textSize = '2';
      break;

    case SIZES.LARGE:
      iconSize = 36;
      textSize = '3';
      break;

    default:
      iconSize = 30;
      textSize = '2';
      break;
  }

  const componentClasses = cx('heading', {
    [`heading--size-${size}`]: size,
    [className]: className,
  });

  return (
    <div className={componentClasses}>
      {icon && (
        <ReactSvg
          className={cx('heading__icon')}
          toDisplay={icon}
          options={{
            fillColor: iconColour,
          }}
          width={iconSize}
          height={iconSize}
        />
      )}
      <Text
        className={cx(
          `${wrapLongText ? 'heading__text--wrapped' : 'heading__text'}`,
        )}
        size={textSize}
        type={type}
        align={align}
        strong
      >
        {text}
      </Text>
    </div>
  );
};

Heading.propTypes = {
  text: PropTypes.string.isRequired,

  /** Size of the heading */
  size: PropTypes.oneOf(Object.values(SIZES)),
  type: PropTypes.string,
  align: PropTypes.string,
  wrapLongText: PropTypes.bool,

  icon: PropTypes.shape({}),
  iconColour: PropTypes.string,

  /** Extra classes */
  className: PropTypes.string,
};

Heading.defaultProps = {
  size: SIZES.MEDIUM,
  type: 'title',
  icon: null,
  align: null,
  wrapLongText: false,
  iconColour: '#262A61',
  className: '',
};

export default Heading;
